/* tslint:disable */
/* eslint-disable */
/**
 * elegislativa Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AktEu
 */
export interface AktEu {
    /**
     * 
     * @type {string}
     * @memberof AktEu
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AktEu
     */
    'aktEuId': string;
}
/**
 * 
 * @export
 * @interface CiselnikPolozka
 */
export interface CiselnikPolozka {
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'nazov': string;
    /**
     * 
     * @type {number}
     * @memberof CiselnikPolozka
     */
    'uroven'?: number;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'kod'?: string;
    /**
     * 
     * @type {string}
     * @memberof CiselnikPolozka
     */
    'prefix'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'legislativny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'platny'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'existujeFormular'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'generovanySystemom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CiselnikPolozka
     */
    'povolitZadavanieFormularom'?: boolean;
}
/**
 * 
 * @export
 * @interface DalsiPredkladatel
 */
export interface DalsiPredkladatel {
    /**
     * 
     * @type {SubjectItem}
     * @memberof DalsiPredkladatel
     */
    'predkladatel': SubjectItem;
    /**
     * 
     * @type {Organizacia}
     * @memberof DalsiPredkladatel
     */
    'organizacia': Organizacia;
}
/**
 * 
 * @export
 * @interface DalsiPredkladatelUuid
 */
export interface DalsiPredkladatelUuid {
    /**
     * 
     * @type {string}
     * @memberof DalsiPredkladatelUuid
     */
    'predkladatelUuid': string;
    /**
     * 
     * @type {string}
     * @memberof DalsiPredkladatelUuid
     */
    'organizaciaUuid': string;
}
/**
 * 
 * @export
 * @interface Dolezitost
 */
export interface Dolezitost {
    /**
     * 
     * @type {DolezitostEnum}
     * @memberof Dolezitost
     */
    'hodnota': DolezitostEnum;
    /**
     * 
     * @type {string}
     * @memberof Dolezitost
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @interface DolezitostAktEu
 */
export interface DolezitostAktEu {
    /**
     * 
     * @type {DolezitostEnum}
     * @memberof DolezitostAktEu
     */
    'dolezitost'?: DolezitostEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DolezitostEnum = {
    Vyssia: 'VYSSIA',
    Stredna: 'STREDNA',
    Nizsia: 'NIZSIA'
} as const;

export type DolezitostEnum = typeof DolezitostEnum[keyof typeof DolezitostEnum];


/**
 * 
 * @export
 * @interface Kategoria
 */
export interface Kategoria {
    /**
     * 
     * @type {KategoriaEnum}
     * @memberof Kategoria
     */
    'hodnota': KategoriaEnum;
    /**
     * 
     * @type {string}
     * @memberof Kategoria
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @interface KategoriaAktEu
 */
export interface KategoriaAktEu {
    /**
     * 
     * @type {KategoriaEnum}
     * @memberof KategoriaAktEu
     */
    'kategoria'?: KategoriaEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const KategoriaEnum = {
    Legislativny: 'LEGISLATIVNY',
    Nelegislativny: 'NELEGISLATIVNY',
    Iny: 'INY'
} as const;

export type KategoriaEnum = typeof KategoriaEnum[keyof typeof KategoriaEnum];


/**
 * 
 * @export
 * @interface LegMaterialCreate
 */
export interface LegMaterialCreate {
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'podnet'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegMaterialCreate
     */
    'suvisiaceProcesy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'zodpovednyPredkladatel'?: string;
    /**
     * 
     * @type {Array<DalsiPredkladatelUuid>}
     * @memberof LegMaterialCreate
     */
    'dalsiPredkladatelia'?: Array<DalsiPredkladatelUuid>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'typUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegMaterialCreate
     */
    'oblastListUuid'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialCreate
     */
    'hlavnyNovelizovanyPredpis'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegMaterialCreate
     */
    'novelizovanePredpisy'?: Array<string>;
    /**
     * 
     * @type {LegMaterialCreateStepEnum}
     * @memberof LegMaterialCreate
     */
    'activeStep'?: LegMaterialCreateStepEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const LegMaterialCreateStepEnum = {
    TypMaterialu1: 'TYP_MATERIALU_1',
    BasicData2: 'BASIC_DATA_2',
    Predkladatel4: 'PREDKLADATEL_4'
} as const;

export type LegMaterialCreateStepEnum = typeof LegMaterialCreateStepEnum[keyof typeof LegMaterialCreateStepEnum];


/**
 * 
 * @export
 * @interface LegMaterialDetail
 */
export interface LegMaterialDetail {
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'uuid': string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof LegMaterialDetail
     */
    'typ': CiselnikPolozka;
    /**
     * 
     * @type {Array<CiselnikPolozka>}
     * @memberof LegMaterialDetail
     */
    'oblastList'?: Array<CiselnikPolozka>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'cisloLegislativnehoMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'nazov': string;
    /**
     * 
     * @type {Stadium}
     * @memberof LegMaterialDetail
     */
    'stadium': Stadium;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'poslednaZmena': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'podnet'?: string;
    /**
     * 
     * @type {SubjectItem}
     * @memberof LegMaterialDetail
     */
    'zodpovednyPredkladatel'?: SubjectItem;
    /**
     * 
     * @type {SubjectItem}
     * @memberof LegMaterialDetail
     */
    'aktualnyPredkladatel'?: SubjectItem;
    /**
     * 
     * @type {Array<DalsiPredkladatel>}
     * @memberof LegMaterialDetail
     */
    'dalsiPredkladatelia'?: Array<DalsiPredkladatel>;
    /**
     * 
     * @type {Organizacia}
     * @memberof LegMaterialDetail
     */
    'zodpovednaInstitucia'?: Organizacia;
    /**
     * 
     * @type {Organizacia}
     * @memberof LegMaterialDetail
     */
    'aktualnaInstitucia'?: Organizacia;
    /**
     * 
     * @type {Array<SuvisiaciProces>}
     * @memberof LegMaterialDetail
     */
    'suvisiaceProcesy'?: Array<SuvisiaciProces>;
    /**
     * 
     * @type {NovelizovanyPredpis}
     * @memberof LegMaterialDetail
     */
    'hlavnyNovelizovanyPredpis'?: NovelizovanyPredpis;
    /**
     * 
     * @type {Array<NovelizovanyPredpis>}
     * @memberof LegMaterialDetail
     */
    'novelizovanePredpisy'?: Array<NovelizovanyPredpis>;
    /**
     * 
     * @type {boolean}
     * @memberof LegMaterialDetail
     */
    'skrateneMpk': boolean;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'datumZaciatkuPkMpk'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'datumUkonceniaPkMpk'?: string;
    /**
     * 
     * @type {SablonaProcesu}
     * @memberof LegMaterialDetail
     */
    'sablonaProcesu'?: SablonaProcesu;
    /**
     * 
     * @type {boolean}
     * @memberof LegMaterialDetail
     */
    'sledovany': boolean;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'dovodSkratenehoMpk'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'dovodZruseniaMpk'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'vysledokNrSr'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'dovodUkoncenia'?: string;
    /**
     * 
     * @type {AktEu}
     * @memberof LegMaterialDetail
     */
    'aktEu'?: AktEu;
    /**
     * 
     * @type {Dolezitost}
     * @memberof LegMaterialDetail
     */
    'stupenDolezitostiAktu'?: Dolezitost;
    /**
     * 
     * @type {Organizacia}
     * @memberof LegMaterialDetail
     */
    'gestor'?: Organizacia;
    /**
     * 
     * @type {Array<Organizacia>}
     * @memberof LegMaterialDetail
     */
    'spolugestorList'?: Array<Organizacia>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'dovodOdmietnutiaGestora'?: string;
    /**
     * 
     * @type {Kategoria}
     * @memberof LegMaterialDetail
     */
    'kategoriaAktu'?: Kategoria;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'namietkaKuGestorstvu'?: string;
    /**
     * 
     * @type {Organizacia}
     * @memberof LegMaterialDetail
     */
    'vlastnikAktivity'?: Organizacia;
    /**
     * 
     * @type {boolean}
     * @memberof LegMaterialDetail
     */
    'opravneniePracovneKroky': boolean;
    /**
     * 
     * @type {SubjectItem}
     * @memberof LegMaterialDetail
     */
    'autorProcesu'?: SubjectItem;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'camundaId'?: string;
    /**
     * 
     * @type {Array<Organizacia>}
     * @memberof LegMaterialDetail
     */
    'dalsiPripomienkovatelia'?: Array<Organizacia>;
    /**
     * 
     * @type {Array<Organizacia>}
     * @memberof LegMaterialDetail
     */
    'poradnyOrganVladyList'?: Array<Organizacia>;
    /**
     * 
     * @type {boolean}
     * @memberof LegMaterialDetail
     */
    'opravnenieSprievodneDokumenty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LegMaterialDetail
     */
    'pracovnyKrokInZasobnikPrace'?: boolean;
    /**
     * 
     * @type {Array<NovelizovanyPredpis>}
     * @memberof LegMaterialDetail
     */
    'vyhlasenyPodCislomList'?: Array<NovelizovanyPredpis>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'zaciatokStadiaTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialDetail
     */
    'datumVytvoreniaProcesu'?: string;
}
/**
 * 
 * @export
 * @interface LegMaterialFilterListItem
 */
export interface LegMaterialFilterListItem {
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'typNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'cisloLegislativnehoMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'nazov': string;
    /**
     * 
     * @type {Stadium}
     * @memberof LegMaterialFilterListItem
     */
    'stadium': Stadium;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'zaciatokStadia': string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialFilterListItem
     */
    'datumUkonceniaPkMpk'?: string;
}
/**
 * 
 * @export
 * @interface LegMaterialFilterListPage
 */
export interface LegMaterialFilterListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof LegMaterialFilterListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof LegMaterialFilterListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof LegMaterialFilterListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<LegMaterialFilterListItem>}
     * @memberof LegMaterialFilterListPage
     */
    'legMaterialList'?: Array<LegMaterialFilterListItem>;
}
/**
 * 
 * @export
 * @interface LegMaterialUpdate
 */
export interface LegMaterialUpdate {
    /**
     * 
     * @type {Array<string>}
     * @memberof LegMaterialUpdate
     */
    'oblastListUuid': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'podnet'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegMaterialUpdate
     */
    'suvisiaceProcesy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'zodpovednaInstituciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'zodpovednaInstituciaLdapUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegMaterialUpdate
     */
    'zodpovednyPredkladatelUuid'?: string;
    /**
     * 
     * @type {Array<DalsiPredkladatelUuid>}
     * @memberof LegMaterialUpdate
     */
    'dalsiPredkladatelia'?: Array<DalsiPredkladatelUuid>;
}
/**
 * 
 * @export
 * @interface LegislativnyMaterialFilter
 */
export interface LegislativnyMaterialFilter {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof LegislativnyMaterialFilter
     */
    'stadium'?: StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'cisloLegislativnehoMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'typKod'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegislativnyMaterialFilter
     */
    'oblastKodList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'rocnik'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'zodpovednyPredkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'zodpovednaInstitucia'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'datumZmenyOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegislativnyMaterialFilter
     */
    'datumZmenyDo'?: string;
}


/**
 * 
 * @export
 * @interface MpkCancel
 */
export interface MpkCancel {
    /**
     * 
     * @type {string}
     * @memberof MpkCancel
     */
    'dovodZrusenia'?: string;
}
/**
 * 
 * @export
 * @interface MpkRequest
 */
export interface MpkRequest {
    /**
     * 
     * @type {number}
     * @memberof MpkRequest
     */
    'durationDays': number;
    /**
     * 
     * @type {string}
     * @memberof MpkRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MpkRequest
     */
    'skratene': boolean;
    /**
     * 
     * @type {string}
     * @memberof MpkRequest
     */
    'dovodSkratenia'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MpkRequest
     */
    'pripomienkovatelList': Array<string>;
}
/**
 * 
 * @export
 * @interface NamietkaKuGestorstvu
 */
export interface NamietkaKuGestorstvu {
    /**
     * 
     * @type {string}
     * @memberof NamietkaKuGestorstvu
     */
    'namietka': string;
}
/**
 * 
 * @export
 * @interface NovelizovanyPredpis
 */
export interface NovelizovanyPredpis {
    /**
     * 
     * @type {string}
     * @memberof NovelizovanyPredpis
     */
    'iri'?: string;
    /**
     * 
     * @type {string}
     * @memberof NovelizovanyPredpis
     */
    'menovka'?: string;
    /**
     * 
     * @type {string}
     * @memberof NovelizovanyPredpis
     */
    'popis'?: string;
}
/**
 * 
 * @export
 * @interface ObalMaterialInitData
 */
export interface ObalMaterialInitData {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'nazovVygenerovanehoDokumentu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'zodpovednaInstitucia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'typObalu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'navrh'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'typMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'rok'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'podnet'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'obsahMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialInitData
     */
    'miestoDatum'?: string;
}
/**
 * 
 * @export
 * @interface ObalMaterialNrSrInitData
 */
export interface ObalMaterialNrSrInitData {
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'rezortneCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'cisloParlamentnejTlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'vladnyNavrh'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'typMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'nazovMaterialu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'navrhUznesenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'predkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'zodpovednyPredkladatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'zaBezchybnost'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObalMaterialNrSrInitData
     */
    'miestoDatum'?: string;
}
/**
 * 
 * @export
 * @interface OdmietnutieGestora
 */
export interface OdmietnutieGestora {
    /**
     * 
     * @type {string}
     * @memberof OdmietnutieGestora
     */
    'dovodOdmietnutia'?: string;
}
/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface PracovnyKrok
 */
export interface PracovnyKrok {
    /**
     * 
     * @type {string}
     * @memberof PracovnyKrok
     */
    'nazov': string;
    /**
     * 
     * @type {PracovnyKrokEnum}
     * @memberof PracovnyKrok
     */
    'pracovnyKrok': PracovnyKrokEnum;
    /**
     * 
     * @type {string}
     * @memberof PracovnyKrok
     */
    'pracovnyKrokId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PracovnyKrokEnum = {
    VytvoritSprievodnyDokument: 'VYTVORIT_SPRIEVODNY_DOKUMENT',
    ZrusitMaterial: 'ZRUSIT_MATERIAL',
    PrechodVyjadrenia: 'PRECHOD_VYJADRENIA',
    ZrusitNastaveneVyjadrenia: 'ZRUSIT_NASTAVENE_VYJADRENIA',
    UkoncitProces: 'UKONCIT_PROCES',
    UkoncitProcesBezMpk: 'UKONCIT_PROCES_BEZ_MPK',
    PrechodPredpFazaUkonc: 'PRECHOD_PREDP_FAZA_UKONC',
    NavratPriprava: 'NAVRAT_PRIPRAVA',
    UkoncitProcesPosledneStadium: 'UKONCIT_PROCES_POSLEDNE_STADIUM',
    PrechodMpk: 'PRECHOD_MPK',
    PrechodSpracovaniePredkladatel: 'PRECHOD_SPRACOVANIE_PREDKLADATEL',
    VytvoritPripomienku: 'VYTVORIT_PRIPOMIENKU',
    OdoslatBezPripomienok: 'ODOSLAT_BEZ_PRIPOMIENOK',
    VyhodnotitPripomienky: 'VYHODNOTIT_PRIPOMIENKY',
    ZrusitMpk: 'ZRUSIT_MPK',
    UkoncitMpkTest: 'UKONCIT_MPK_TEST',
    SpustitRokovaniePov: 'SPUSTIT_ROKOVANIE_POV',
    UkoncitRokovaniePov: 'UKONCIT_ROKOVANIE_POV',
    SpustitRokovanieVlady: 'SPUSTIT_ROKOVANIE_VLADY',
    UkoncitRokovanieVlady: 'UKONCIT_ROKOVANIE_VLADY',
    NavratSpracovaniePredkladatel: 'NAVRAT_SPRACOVANIE_PREDKLADATEL',
    OznacitAkoSchvaleny: 'OZNACIT_AKO_SCHVALENY',
    OznacitAkoVzatySpat: 'OZNACIT_AKO_VZATY_SPAT',
    OznacitAkoNeschvaleny: 'OZNACIT_AKO_NESCHVALENY',
    PrechodVyhlaseneVZbierke: 'PRECHOD_VYHLASENE_V_ZBIERKE',
    PrechodRokovanieNrsr: 'PRECHOD_ROKOVANIE_NRSR',
    OznacitAkoSchvalenyMinister: 'OZNACIT_AKO_SCHVALENY_MINISTER',
    OznacitAkoNeschvalenyMinister: 'OZNACIT_AKO_NESCHVALENY_MINISTER',
    UrcitGestorov: 'URCIT_GESTOROV',
    DefinovatStupenDolezitosti: 'DEFINOVAT_STUPEN_DOLEZITOSTI',
    OdoslatNaUvsr: 'ODOSLAT_NA_UVSR',
    SchvalitGestora: 'SCHVALIT_GESTORA',
    SchvalitGestoraPresun: 'SCHVALIT_GESTORA_PRESUN',
    OdmietnutGestora: 'ODMIETNUT_GESTORA',
    DefinovatKategoriu: 'DEFINOVAT_KATEGORIU',
    NamietkaKUrceniuGestorstva: 'NAMIETKA_K_URCENIU_GESTORSTVA',
    ZrusitNastaveneMpk: 'ZRUSIT_NASTAVENE_MPK',
    PrechodPredVyhlasenim: 'PRECHOD_PRED_VYHLASENIM',
    PrechodZapisDoplnenehoPredbStanoviska: 'PRECHOD_ZAPIS_DOPLNENEHO_PREDB_STANOVISKA',
    PrechodVytvorenieFinalStanoviska: 'PRECHOD_VYTVORENIE_FINAL_STANOVISKA',
    PrechodSchvalovanieMinistrom: 'PRECHOD_SCHVALOVANIE_MINISTROM',
    OdoslatPredsedoviVlady: 'ODOSLAT_PREDSEDOVI_VLADY',
    UkoncitVyhodnotenieMpk: 'UKONCIT_VYHODNOTENIE_MPK',
    UkoncitVyhodnotenieMpkAktyeu: 'UKONCIT_VYHODNOTENIE_MPK_AKTYEU',
    SprievodnyDokumentFunction: 'SPRIEVODNY_DOKUMENT_FUNCTION',
    PredkladatelUpdateFunction: 'PREDKLADATEL_UPDATE_FUNCTION',
    ZverejnitNaPortali: 'ZVEREJNIT_NA_PORTALI',
    AdminZmenaStadiaFunction: 'ADMIN_ZMENA_STADIA_FUNCTION'
} as const;

export type PracovnyKrokEnum = typeof PracovnyKrokEnum[keyof typeof PracovnyKrokEnum];


/**
 * 
 * @export
 * @interface PracovnyKrokList
 */
export interface PracovnyKrokList {
    /**
     * 
     * @type {Array<PracovnyKrok>}
     * @memberof PracovnyKrokList
     */
    'pracovneKroky'?: Array<PracovnyKrok>;
}
/**
 * 
 * @export
 * @interface PredkladatelUpdate
 */
export interface PredkladatelUpdate {
    /**
     * 
     * @type {Organizacia}
     * @memberof PredkladatelUpdate
     */
    'aktualnaPredkladatelskaInstitucia'?: Organizacia;
    /**
     * 
     * @type {string}
     * @memberof PredkladatelUpdate
     */
    'aktualnyPredkladatelUuid'?: string;
}
/**
 * 
 * @export
 * @interface ProcessTerminate
 */
export interface ProcessTerminate {
    /**
     * 
     * @type {string}
     * @memberof ProcessTerminate
     */
    'dovodUkoncenia'?: string;
}
/**
 * 
 * @export
 * @interface RokovaniePov
 */
export interface RokovaniePov {
    /**
     * 
     * @type {Array<string>}
     * @memberof RokovaniePov
     */
    'poradneOrganyVlady'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SablonaProcesu
 */
export interface SablonaProcesu {
    /**
     * 
     * @type {string}
     * @memberof SablonaProcesu
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SablonaProcesu
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof SablonaProcesu
     */
    'processId': string;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaPrednastavenaHodnota'?: number;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaOd'?: number;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaDo'?: number;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaSkratenaPrednastavenaHodnota'?: number;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaSkratenaOd'?: number;
    /**
     * 
     * @type {number}
     * @memberof SablonaProcesu
     */
    'lehotaSkratenaDo'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface SprievodnyDokumentMergedItem
 */
export interface SprievodnyDokumentMergedItem {
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'sprievodnyDokumentUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SprievodnyDokumentMergedItem
     */
    'povinny'?: boolean;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof SprievodnyDokumentMergedItem
     */
    'typDokumentu'?: CiselnikPolozka;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'sablonaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'fileS3Path'?: string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'nazov'?: string;
    /**
     * 
     * @type {number}
     * @memberof SprievodnyDokumentMergedItem
     */
    'velkost'?: number;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'datumVytvorenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof SprievodnyDokumentMergedItem
     */
    'formData'?: string;
}
/**
 * 
 * @export
 * @interface Stadium
 */
export interface Stadium {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof Stadium
     */
    'hodnota': StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof Stadium
     */
    'nazov': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA',
    ZapisPredbeznehoStanoviska: 'ZAPIS_PREDBEZNEHO_STANOVISKA',
    ZapisDoplnenehoPredbeznehoStanoviska: 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
    AdministraciaProcesu: 'ADMINISTRACIA_PROCESU',
    AproximaciaNariadenia: 'APROXIMACIA_NARIADENIA',
    AproximaciaSmernice: 'APROXIMACIA_SMERNICE',
    ArchivovanyAeu: 'ARCHIVOVANY_AEU',
    CakajuciPubMod: 'CAKAJUCI_PUB_MOD',
    DoplneniePozicie: 'DOPLNENIE_POZICIE',
    FinalizaciaInstrukcie: 'FINALIZACIA_INSTRUKCIE',
    FinalizaciaNotifikacnychFormularov: 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
    FinalizaciaPozicie: 'FINALIZACIA_POZICIE',
    KontrolaRedakcUprav: 'KONTROLA_REDAKC_UPRAV',
    MzvEz: 'MZV_EZ',
    NotifikacnyFormular: 'NOTIFIKACNY_FORMULAR',
    OdoslaneRokovanieNrsr: 'ODOSLANE_ROKOVANIE_NRSR',
    OdoslaneRokovanieVlady: 'ODOSLANE_ROKOVANIE_VLADY',
    OdoslaneZz: 'ODOSLANE_ZZ',
    PredPublikovanim: 'PRED_PUBLIKOVANIM',
    PriebezneZapracovaniePrip: 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
    PripomienkovaniePozmenNavrhovNrsr: 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
    PripravaMaterialuAdmin: 'PRIPRAVA_MATERIALU_ADMIN',
    PripravaMaterialuPi: 'PRIPRAVA_MATERIALU_PI',
    PripravaNelegMaterialu: 'PRIPRAVA_NELEG_MATERIALU',
    PriradenieGestoraCoreper: 'PRIRADENIE_GESTORA_COREPER',
    PriradenieGestoraNariadenie: 'PRIRADENIE_GESTORA_NARIADENIE',
    PriradenieGestoraRadaEu: 'PRIRADENIE_GESTORA_RADA_EU',
    PriradenieGestoraSmernica: 'PRIRADENIE_GESTORA_SMERNICA',
    PublikaciaRo: 'PUBLIKACIA_RO',
    RokovanieLrv: 'ROKOVANIE_LRV',
    RokovanieNrsrNelegMat: 'ROKOVANIE_NRSR_NELEG_MAT',
    RokovaniePracKomisii: 'ROKOVANIE_PRAC_KOMISII',
    RokovaniePredkladatel: 'ROKOVANIE_PREDKLADATEL',
    RokovaniePredkladatelNelegMat: 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
    RokovanieVladaNelegMat: 'ROKOVANIE_VLADA_NELEG_MAT',
    SefredaktorPridelovanie: 'SEFREDAKTOR_PRIDELOVANIE',
    SefredaktorSchvaleniePredPubmod: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
    SefredaktorSchvaleniePredPubmodNelegMat: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
    SchvaleneNaVlade: 'SCHVALENE_NA_VLADE',
    SchvalovaniePrezident: 'SCHVALOVANIE_PREZIDENT',
    SpracovanieRedaktor: 'SPRACOVANIE_REDAKTOR',
    SpracovanieRedaktorNelegMat: 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
    SpracovanieSefredaktor: 'SPRACOVANIE_SEFREDAKTOR',
    SpracovanieSefredaktorNelegMat: 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
    VyhodnotenieMpkNelegMat: 'VYHODNOTENIE_MPK_NELEG_MAT',
    VyhodnotenieRokovaniaNrsr: 'VYHODNOTENIE_ROKOVANIA_NRSR',
    VyhodnotenieVysledkuRokovania: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
    VyhodnotenieVysledkuRokovaniaNelegMat: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
    VytvorenieCiastkovejInstrukcie: 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
    VytvoreniePozicie: 'VYTVORENIE_POZICIE',
    ZaevidovanieMaterialu: 'ZAEVIDOVANIE_MATERIALU',
    ZaevidovanieOpatrenia: 'ZAEVIDOVANIE_OPATRENIA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];


/**
 * 
 * @export
 * @interface SubjectItem
 */
export interface SubjectItem {
    /**
     * 
     * @type {string}
     * @memberof SubjectItem
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectItem
     */
    'celeMeno'?: string;
}
/**
 * 
 * @export
 * @interface SuvisiaciProces
 */
export interface SuvisiaciProces {
    /**
     * 
     * @type {string}
     * @memberof SuvisiaciProces
     */
    'cisloLp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuvisiaciProces
     */
    'nazov'?: string;
}
/**
 * 
 * @export
 * @interface UkoncenieVyhodnoteniaMpk
 */
export interface UkoncenieVyhodnoteniaMpk {
    /**
     * 
     * @type {string}
     * @memberof UkoncenieVyhodnoteniaMpk
     */
    'cisloLegislativnehoMaterialu'?: string;
    /**
     * 
     * @type {PracovnyKrokEnum}
     * @memberof UkoncenieVyhodnoteniaMpk
     */
    'pracovnyKrok'?: PracovnyKrokEnum;
}


/**
 * 
 * @export
 * @interface UlohaListItem
 */
export interface UlohaListItem {
    /**
     * 
     * @type {string}
     * @memberof UlohaListItem
     */
    'uuid': string;
    /**
     * 
     * @type {CiselnikPolozka}
     * @memberof UlohaListItem
     */
    'typ': CiselnikPolozka;
    /**
     * 
     * @type {string}
     * @memberof UlohaListItem
     */
    'cisloLegislativnehoMaterialu': string;
    /**
     * 
     * @type {string}
     * @memberof UlohaListItem
     */
    'nazov': string;
    /**
     * 
     * @type {Stadium}
     * @memberof UlohaListItem
     */
    'stadium': Stadium;
    /**
     * 
     * @type {string}
     * @memberof UlohaListItem
     */
    'datumPrijatia': string;
    /**
     * 
     * @type {string}
     * @memberof UlohaListItem
     */
    'datumVybavenia'?: string;
    /**
     * 
     * @type {Array<PracovnyKrok>}
     * @memberof UlohaListItem
     */
    'pracovnyKrokList'?: Array<PracovnyKrok>;
}
/**
 * 
 * @export
 * @interface UlohaListPage
 */
export interface UlohaListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof UlohaListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof UlohaListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof UlohaListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<UlohaListItem>}
     * @memberof UlohaListPage
     */
    'legMaterialList'?: Array<UlohaListItem>;
}
/**
 * 
 * @export
 * @interface UlohyOrganizacie
 */
export interface UlohyOrganizacie {
    /**
     * 
     * @type {number}
     * @memberof UlohyOrganizacie
     */
    'pocetUloh'?: number;
    /**
     * 
     * @type {SubjectItem}
     * @memberof UlohyOrganizacie
     */
    'subject'?: SubjectItem;
}
/**
 * 
 * @export
 * @interface UlohyOrganizaciePage
 */
export interface UlohyOrganizaciePage {
    /**
     * total count of elements
     * @type {number}
     * @memberof UlohyOrganizaciePage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof UlohyOrganizaciePage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof UlohyOrganizaciePage
     */
    'size': number;
    /**
     * 
     * @type {Array<UlohyOrganizacie>}
     * @memberof UlohyOrganizaciePage
     */
    'ulohyOrganizacie'?: Array<UlohyOrganizacie>;
}
/**
 * 
 * @export
 * @interface UrcenieGestora
 */
export interface UrcenieGestora {
    /**
     * 
     * @type {string}
     * @memberof UrcenieGestora
     */
    'gestorUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UrcenieGestora
     */
    'spolugestorList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaSkratka'?: string;
    /**
     * 
     * @type {Array<UserRoleEnum>}
     * @memberof UserDetail
     */
    'roleList'?: Array<UserRoleEnum>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserRoleEnum = {
    AdministratorTezaurus: 'ADMINISTRATOR_TEZAURUS',
    AktyEu: 'AKTY_EU',
    AktyEuSpravca: 'AKTY_EU_SPRAVCA',
    Clen: 'CLEN',
    NelegislativnaOrganizacia: 'NELEGISLATIVNA_ORGANIZACIA',
    Odosielatel: 'ODOSIELATEL',
    PredkladatelLeg: 'PREDKLADATEL_LEG',
    PredkladatelNeleg: 'PREDKLADATEL_NELEG',
    PredkladatelZodp: 'PREDKLADATEL_ZODP',
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    RedaktorTezaurus: 'REDAKTOR_TEZAURUS',
    RezortneZbierkyImport: 'REZORTNE_ZBIERKY_IMPORT',
    RezortneZbierkySpravca: 'REZORTNE_ZBIERKY_SPRAVCA',
    SchvalovatelTezaurus: 'SCHVALOVATEL_TEZAURUS',
    SchvalovatelVlada: 'SCHVALOVATEL_VLADA',
    Spracovatel: 'SPRACOVATEL',
    SudneRozhodnutiaEuSpravca: 'SUDNE_ROZHODNUTIA_EU_SPRAVCA',
    Superadmin: 'SUPERADMIN',
    VeduciOrganizacie: 'VEDUCI_ORGANIZACIE',
    Verejnost: 'VEREJNOST',
    VyhlasovatelPortal: 'VYHLASOVATEL_PORTAL',
    Vyhodnocovatel: 'VYHODNOCOVATEL'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];


/**
 * 
 * @export
 * @interface Vyjadrenia
 */
export interface Vyjadrenia {
    /**
     * 
     * @type {number}
     * @memberof Vyjadrenia
     */
    'durationDays': number;
    /**
     * 
     * @type {string}
     * @memberof Vyjadrenia
     */
    'startDate'?: string;
}
/**
 * 
 * @export
 * @interface ZmenaStadia
 */
export interface ZmenaStadia {
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof ZmenaStadia
     */
    'stadium': StadiumMaterialuEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ZmenaStadia
     */
    'skipServiceTasks': boolean;
    /**
     * 
     * @type {string}
     * @memberof ZmenaStadia
     */
    'typMaterialuKod'?: string;
}


/**
 * 
 * @export
 * @interface ZodpovednyPredkladatel
 */
export interface ZodpovednyPredkladatel {
    /**
     * 
     * @type {string}
     * @memberof ZodpovednyPredkladatel
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZodpovednyPredkladatel
     */
    'fullName'?: string;
}

/**
 * DolezitostAktEuApi - axios parameter creator
 * @export
 */
export const DolezitostAktEuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set stupen dolezitosti navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {DolezitostAktEu} [dolezitostAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDolezitost: async (type: string, year: number, index: number, dolezitostAktEu?: DolezitostAktEu, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('setDolezitost', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('setDolezitost', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('setDolezitost', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/dolezitost-akt-eu`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dolezitostAktEu, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DolezitostAktEuApi - functional programming interface
 * @export
 */
export const DolezitostAktEuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DolezitostAktEuApiAxiosParamCreator(configuration)
    return {
        /**
         * Set stupen dolezitosti navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {DolezitostAktEu} [dolezitostAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDolezitost(type: string, year: number, index: number, dolezitostAktEu?: DolezitostAktEu, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDolezitost(type, year, index, dolezitostAktEu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DolezitostAktEuApi.setDolezitost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DolezitostAktEuApi - factory interface
 * @export
 */
export const DolezitostAktEuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DolezitostAktEuApiFp(configuration)
    return {
        /**
         * Set stupen dolezitosti navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {DolezitostAktEu} [dolezitostAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDolezitost(type: string, year: number, index: number, dolezitostAktEu?: DolezitostAktEu, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDolezitost(type, year, index, dolezitostAktEu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DolezitostAktEuApi - object-oriented interface
 * @export
 * @class DolezitostAktEuApi
 * @extends {BaseAPI}
 */
export class DolezitostAktEuApi extends BaseAPI {
    /**
     * Set stupen dolezitosti navrhu for material of type - Akt EU.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {DolezitostAktEu} [dolezitostAktEu] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DolezitostAktEuApi
     */
    public setDolezitost(type: string, year: number, index: number, dolezitostAktEu?: DolezitostAktEu, options?: RawAxiosRequestConfig) {
        return DolezitostAktEuApiFp(this.configuration).setDolezitost(type, year, index, dolezitostAktEu, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KategoriaAktEuApi - axios parameter creator
 * @export
 */
export const KategoriaAktEuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set kategoriu navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {KategoriaAktEu} [kategoriaAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setKategoria: async (type: string, year: number, index: number, kategoriaAktEu?: KategoriaAktEu, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('setKategoria', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('setKategoria', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('setKategoria', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/kategoria-akt-eu`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(kategoriaAktEu, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KategoriaAktEuApi - functional programming interface
 * @export
 */
export const KategoriaAktEuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KategoriaAktEuApiAxiosParamCreator(configuration)
    return {
        /**
         * Set kategoriu navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {KategoriaAktEu} [kategoriaAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setKategoria(type: string, year: number, index: number, kategoriaAktEu?: KategoriaAktEu, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setKategoria(type, year, index, kategoriaAktEu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KategoriaAktEuApi.setKategoria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KategoriaAktEuApi - factory interface
 * @export
 */
export const KategoriaAktEuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KategoriaAktEuApiFp(configuration)
    return {
        /**
         * Set kategoriu navrhu for material of type - Akt EU.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {KategoriaAktEu} [kategoriaAktEu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setKategoria(type: string, year: number, index: number, kategoriaAktEu?: KategoriaAktEu, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setKategoria(type, year, index, kategoriaAktEu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KategoriaAktEuApi - object-oriented interface
 * @export
 * @class KategoriaAktEuApi
 * @extends {BaseAPI}
 */
export class KategoriaAktEuApi extends BaseAPI {
    /**
     * Set kategoriu navrhu for material of type - Akt EU.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {KategoriaAktEu} [kategoriaAktEu] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KategoriaAktEuApi
     */
    public setKategoria(type: string, year: number, index: number, kategoriaAktEu?: KategoriaAktEu, options?: RawAxiosRequestConfig) {
        return KategoriaAktEuApiFp(this.configuration).setKategoria(type, year, index, kategoriaAktEu, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialCreateApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialCreateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create legislativny material.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegMaterial: async (legMaterialCreate: LegMaterialCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legMaterialCreate' is not null or undefined
            assertParamExists('createLegMaterial', 'legMaterialCreate', legMaterialCreate)
            const localVarPath = `/legislativne-materialy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legMaterialCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate create legislativny material in active step.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLegMaterial: async (legMaterialCreate: LegMaterialCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legMaterialCreate' is not null or undefined
            assertParamExists('validateLegMaterial', 'legMaterialCreate', legMaterialCreate)
            const localVarPath = `/legislativne-materialy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legMaterialCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialCreateApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialCreateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialCreateApiAxiosParamCreator(configuration)
    return {
        /**
         * Create legislativny material.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLegMaterial(legMaterialCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialCreateApi.createLegMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate create legislativny material in active step.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateLegMaterial(legMaterialCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialCreateApi.validateLegMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialCreateApi - factory interface
 * @export
 */
export const LegislativnyMaterialCreateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialCreateApiFp(configuration)
    return {
        /**
         * Create legislativny material.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createLegMaterial(legMaterialCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate create legislativny material in active step.
         * @param {LegMaterialCreate} legMaterialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateLegMaterial(legMaterialCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialCreateApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialCreateApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialCreateApi extends BaseAPI {
    /**
     * Create legislativny material.
     * @param {LegMaterialCreate} legMaterialCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialCreateApi
     */
    public createLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialCreateApiFp(this.configuration).createLegMaterial(legMaterialCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate create legislativny material in active step.
     * @param {LegMaterialCreate} legMaterialCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialCreateApi
     */
    public validateLegMaterial(legMaterialCreate: LegMaterialCreate, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialCreateApiFp(this.configuration).validateLegMaterial(legMaterialCreate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialDetailApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get detail of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialDetail: async (type: string, year: number, index: number, pracovnyKrok?: PracovnyKrokEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getLegMaterialDetail', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getLegMaterialDetail', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getLegMaterialDetail', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnyKrok !== undefined) {
                localVarQueryParameter['pracovnyKrok'] = pracovnyKrok;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialDetailApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Get detail of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegMaterialDetail(type: string, year: number, index: number, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegMaterialDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegMaterialDetail(type, year, index, pracovnyKrok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialDetailApi.getLegMaterialDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialDetailApi - factory interface
 * @export
 */
export const LegislativnyMaterialDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialDetailApiFp(configuration)
    return {
        /**
         * Get detail of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialDetail(type: string, year: number, index: number, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig): AxiosPromise<LegMaterialDetail> {
            return localVarFp.getLegMaterialDetail(type, year, index, pracovnyKrok, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialDetailApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialDetailApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialDetailApi extends BaseAPI {
    /**
     * Get detail of legislativny material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialDetailApi
     */
    public getLegMaterialDetail(type: string, year: number, index: number, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialDetailApiFp(this.configuration).getLegMaterialDetail(type, year, index, pracovnyKrok, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialFilterListApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialFilterListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get filtered list of existing legislativny material.
         * @param {LegislativnyMaterialFilter} legislativnyMaterialFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialFilteredList: async (legislativnyMaterialFilter: LegislativnyMaterialFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legislativnyMaterialFilter' is not null or undefined
            assertParamExists('getLegMaterialFilteredList', 'legislativnyMaterialFilter', legislativnyMaterialFilter)
            const localVarPath = `/legislativne-materialy/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legislativnyMaterialFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialFilterListApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialFilterListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialFilterListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get filtered list of existing legislativny material.
         * @param {LegislativnyMaterialFilter} legislativnyMaterialFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegMaterialFilteredList(legislativnyMaterialFilter: LegislativnyMaterialFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegMaterialFilterListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegMaterialFilteredList(legislativnyMaterialFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialFilterListApi.getLegMaterialFilteredList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialFilterListApi - factory interface
 * @export
 */
export const LegislativnyMaterialFilterListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialFilterListApiFp(configuration)
    return {
        /**
         * Get filtered list of existing legislativny material.
         * @param {LegislativnyMaterialFilter} legislativnyMaterialFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialFilteredList(legislativnyMaterialFilter: LegislativnyMaterialFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<LegMaterialFilterListPage> {
            return localVarFp.getLegMaterialFilteredList(legislativnyMaterialFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialFilterListApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialFilterListApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialFilterListApi extends BaseAPI {
    /**
     * Get filtered list of existing legislativny material.
     * @param {LegislativnyMaterialFilter} legislativnyMaterialFilter 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialFilterListApi
     */
    public getLegMaterialFilteredList(legislativnyMaterialFilter: LegislativnyMaterialFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialFilterListApiFp(this.configuration).getLegMaterialFilteredList(legislativnyMaterialFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialListApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of sledovany legislativny material.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSledovanyLegMaterialList: async (page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legislativne-materialy/sledovane`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialListApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of sledovany legislativny material.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSledovanyLegMaterialList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegMaterialFilterListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSledovanyLegMaterialList(page, size, sortBy, sortDirection, searchText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialListApi.getSledovanyLegMaterialList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialListApi - factory interface
 * @export
 */
export const LegislativnyMaterialListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialListApiFp(configuration)
    return {
        /**
         * Get list of sledovany legislativny material.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSledovanyLegMaterialList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, options?: RawAxiosRequestConfig): AxiosPromise<LegMaterialFilterListPage> {
            return localVarFp.getSledovanyLegMaterialList(page, size, sortBy, sortDirection, searchText, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialListApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialListApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialListApi extends BaseAPI {
    /**
     * Get list of sledovany legislativny material.
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {string} [searchText] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialListApi
     */
    public getSledovanyLegMaterialList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialListApiFp(this.configuration).getSledovanyLegMaterialList(page, size, sortBy, sortDirection, searchText, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialRssApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialRssApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get rss of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialRss: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getLegMaterialRss', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getLegMaterialRss', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getLegMaterialRss', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/rss`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialRssApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialRssApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialRssApiAxiosParamCreator(configuration)
    return {
        /**
         * Get rss of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegMaterialRss(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegMaterialRss(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialRssApi.getLegMaterialRss']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialRssApi - factory interface
 * @export
 */
export const LegislativnyMaterialRssApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialRssApiFp(configuration)
    return {
        /**
         * Get rss of legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegMaterialRss(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getLegMaterialRss(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialRssApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialRssApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialRssApi extends BaseAPI {
    /**
     * Get rss of legislativny material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialRssApi
     */
    public getLegMaterialRss(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialRssApiFp(this.configuration).getLegMaterialRss(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialUlohaListApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialUlohaListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of uloha.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {boolean} [ibaAktualnyPredklatel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohaList: async (page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, ibaAktualnyPredklatel?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legislativne-materialy/ulohy/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (ibaAktualnyPredklatel !== undefined) {
                localVarQueryParameter['ibaAktualnyPredklatel'] = ibaAktualnyPredklatel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialUlohaListApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialUlohaListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialUlohaListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of uloha.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {boolean} [ibaAktualnyPredklatel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUlohaList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, ibaAktualnyPredklatel?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UlohaListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUlohaList(page, size, sortBy, sortDirection, searchText, ibaAktualnyPredklatel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialUlohaListApi.getUlohaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialUlohaListApi - factory interface
 * @export
 */
export const LegislativnyMaterialUlohaListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialUlohaListApiFp(configuration)
    return {
        /**
         * Get list of uloha.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [searchText] 
         * @param {boolean} [ibaAktualnyPredklatel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohaList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, ibaAktualnyPredklatel?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<UlohaListPage> {
            return localVarFp.getUlohaList(page, size, sortBy, sortDirection, searchText, ibaAktualnyPredklatel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialUlohaListApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialUlohaListApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialUlohaListApi extends BaseAPI {
    /**
     * Get list of uloha.
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {string} [searchText] 
     * @param {boolean} [ibaAktualnyPredklatel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialUlohaListApi
     */
    public getUlohaList(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, searchText?: string, ibaAktualnyPredklatel?: boolean, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialUlohaListApiFp(this.configuration).getUlohaList(page, size, sortBy, sortDirection, searchText, ibaAktualnyPredklatel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegislativnyMaterialUpdateApi - axios parameter creator
 * @export
 */
export const LegislativnyMaterialUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {LegMaterialUpdate} legMaterialUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegMaterial: async (type: string, year: number, index: number, legMaterialUpdate: LegMaterialUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateLegMaterial', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateLegMaterial', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('updateLegMaterial', 'index', index)
            // verify required parameter 'legMaterialUpdate' is not null or undefined
            assertParamExists('updateLegMaterial', 'legMaterialUpdate', legMaterialUpdate)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legMaterialUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegislativnyMaterialUpdateApi - functional programming interface
 * @export
 */
export const LegislativnyMaterialUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegislativnyMaterialUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {LegMaterialUpdate} legMaterialUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLegMaterial(type: string, year: number, index: number, legMaterialUpdate: LegMaterialUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLegMaterial(type, year, index, legMaterialUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegislativnyMaterialUpdateApi.updateLegMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegislativnyMaterialUpdateApi - factory interface
 * @export
 */
export const LegislativnyMaterialUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegislativnyMaterialUpdateApiFp(configuration)
    return {
        /**
         * Update legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {LegMaterialUpdate} legMaterialUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegMaterial(type: string, year: number, index: number, legMaterialUpdate: LegMaterialUpdate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLegMaterial(type, year, index, legMaterialUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegislativnyMaterialUpdateApi - object-oriented interface
 * @export
 * @class LegislativnyMaterialUpdateApi
 * @extends {BaseAPI}
 */
export class LegislativnyMaterialUpdateApi extends BaseAPI {
    /**
     * Update legislativny material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {LegMaterialUpdate} legMaterialUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegislativnyMaterialUpdateApi
     */
    public updateLegMaterial(type: string, year: number, index: number, legMaterialUpdate: LegMaterialUpdate, options?: RawAxiosRequestConfig) {
        return LegislativnyMaterialUpdateApiFp(this.configuration).updateLegMaterial(type, year, index, legMaterialUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MpkAdminCancelApi - axios parameter creator
 * @export
 */
export const MpkAdminCancelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel stadium MPK for specified material by admin.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMpkByAdmin: async (type: string, year: number, index: number, mpkCancel?: MpkCancel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('cancelMpkByAdmin', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('cancelMpkByAdmin', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('cancelMpkByAdmin', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/zrusenie-mpk`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mpkCancel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MpkAdminCancelApi - functional programming interface
 * @export
 */
export const MpkAdminCancelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MpkAdminCancelApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel stadium MPK for specified material by admin.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMpkByAdmin(type: string, year: number, index: number, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMpkByAdmin(type, year, index, mpkCancel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MpkAdminCancelApi.cancelMpkByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MpkAdminCancelApi - factory interface
 * @export
 */
export const MpkAdminCancelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MpkAdminCancelApiFp(configuration)
    return {
        /**
         * Cancel stadium MPK for specified material by admin.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMpkByAdmin(type: string, year: number, index: number, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelMpkByAdmin(type, year, index, mpkCancel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MpkAdminCancelApi - object-oriented interface
 * @export
 * @class MpkAdminCancelApi
 * @extends {BaseAPI}
 */
export class MpkAdminCancelApi extends BaseAPI {
    /**
     * Cancel stadium MPK for specified material by admin.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {MpkCancel} [mpkCancel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MpkAdminCancelApi
     */
    public cancelMpkByAdmin(type: string, year: number, index: number, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig) {
        return MpkAdminCancelApiFp(this.configuration).cancelMpkByAdmin(type, year, index, mpkCancel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MpkCancelApi - axios parameter creator
 * @export
 */
export const MpkCancelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMpk: async (type: string, year: number, index: number, id: string, mpkCancel?: MpkCancel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('cancelMpk', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('cancelMpk', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('cancelMpk', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelMpk', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/zrusenie-mpk/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mpkCancel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MpkCancelApi - functional programming interface
 * @export
 */
export const MpkCancelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MpkCancelApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelMpk(type: string, year: number, index: number, id: string, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelMpk(type, year, index, id, mpkCancel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MpkCancelApi.cancelMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MpkCancelApi - factory interface
 * @export
 */
export const MpkCancelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MpkCancelApiFp(configuration)
    return {
        /**
         * Cancel stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkCancel} [mpkCancel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelMpk(type: string, year: number, index: number, id: string, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelMpk(type, year, index, id, mpkCancel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MpkCancelApi - object-oriented interface
 * @export
 * @class MpkCancelApi
 * @extends {BaseAPI}
 */
export class MpkCancelApi extends BaseAPI {
    /**
     * Cancel stadium MPK for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {MpkCancel} [mpkCancel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MpkCancelApi
     */
    public cancelMpk(type: string, year: number, index: number, id: string, mpkCancel?: MpkCancel, options?: RawAxiosRequestConfig) {
        return MpkCancelApiFp(this.configuration).cancelMpk(type, year, index, id, mpkCancel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NamietkaKuGestorstvuApi - axios parameter creator
 * @export
 */
export const NamietkaKuGestorstvuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set namietka ku gestorstvu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {NamietkaKuGestorstvu} [namietkaKuGestorstvu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNamietkaKuGestorstvu: async (type: string, year: number, index: number, id: string, namietkaKuGestorstvu?: NamietkaKuGestorstvu, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('setNamietkaKuGestorstvu', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('setNamietkaKuGestorstvu', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('setNamietkaKuGestorstvu', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setNamietkaKuGestorstvu', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/namietka-ku-gestorstvu/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(namietkaKuGestorstvu, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NamietkaKuGestorstvuApi - functional programming interface
 * @export
 */
export const NamietkaKuGestorstvuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NamietkaKuGestorstvuApiAxiosParamCreator(configuration)
    return {
        /**
         * Set namietka ku gestorstvu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {NamietkaKuGestorstvu} [namietkaKuGestorstvu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNamietkaKuGestorstvu(type: string, year: number, index: number, id: string, namietkaKuGestorstvu?: NamietkaKuGestorstvu, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNamietkaKuGestorstvu(type, year, index, id, namietkaKuGestorstvu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NamietkaKuGestorstvuApi.setNamietkaKuGestorstvu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NamietkaKuGestorstvuApi - factory interface
 * @export
 */
export const NamietkaKuGestorstvuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NamietkaKuGestorstvuApiFp(configuration)
    return {
        /**
         * Set namietka ku gestorstvu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {NamietkaKuGestorstvu} [namietkaKuGestorstvu] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNamietkaKuGestorstvu(type: string, year: number, index: number, id: string, namietkaKuGestorstvu?: NamietkaKuGestorstvu, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setNamietkaKuGestorstvu(type, year, index, id, namietkaKuGestorstvu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NamietkaKuGestorstvuApi - object-oriented interface
 * @export
 * @class NamietkaKuGestorstvuApi
 * @extends {BaseAPI}
 */
export class NamietkaKuGestorstvuApi extends BaseAPI {
    /**
     * Set namietka ku gestorstvu for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {NamietkaKuGestorstvu} [namietkaKuGestorstvu] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NamietkaKuGestorstvuApi
     */
    public setNamietkaKuGestorstvu(type: string, year: number, index: number, id: string, namietkaKuGestorstvu?: NamietkaKuGestorstvu, options?: RawAxiosRequestConfig) {
        return NamietkaKuGestorstvuApiFp(this.configuration).setNamietkaKuGestorstvu(type, year, index, id, namietkaKuGestorstvu, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObalMaterialInitDataApi - axios parameter creator
 * @export
 */
export const ObalMaterialInitDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get initial data for obal materialu NR SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialDataForObalMaterialuNrSr: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuNrSr', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuNrSr', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuNrSr', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/obal-materialu-nrsr/init-data`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get initial data for vseobceny obal materialu.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialDataForObalMaterialuVseobecny: async (type: string, year: number, index: number, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuVseobecny', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuVseobecny', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getInitialDataForObalMaterialuVseobecny', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/obal-materialu-vseobecny/init-data`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }

            if (stadiumMaterialu !== undefined) {
                localVarQueryParameter['stadiumMaterialu'] = stadiumMaterialu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObalMaterialInitDataApi - functional programming interface
 * @export
 */
export const ObalMaterialInitDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObalMaterialInitDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get initial data for obal materialu NR SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialDataForObalMaterialuNrSr(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObalMaterialNrSrInitData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialDataForObalMaterialuNrSr(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialInitDataApi.getInitialDataForObalMaterialuNrSr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get initial data for vseobceny obal materialu.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialDataForObalMaterialuVseobecny(type: string, year: number, index: number, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObalMaterialInitData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialDataForObalMaterialuVseobecny(type, year, index, stadiumUuid, stadiumMaterialu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObalMaterialInitDataApi.getInitialDataForObalMaterialuVseobecny']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObalMaterialInitDataApi - factory interface
 * @export
 */
export const ObalMaterialInitDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObalMaterialInitDataApiFp(configuration)
    return {
        /**
         * Get initial data for obal materialu NR SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialDataForObalMaterialuNrSr(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<ObalMaterialNrSrInitData> {
            return localVarFp.getInitialDataForObalMaterialuNrSr(type, year, index, options).then((request) => request(axios, basePath));
        },
        /**
         * Get initial data for vseobceny obal materialu.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialDataForObalMaterialuVseobecny(type: string, year: number, index: number, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig): AxiosPromise<ObalMaterialInitData> {
            return localVarFp.getInitialDataForObalMaterialuVseobecny(type, year, index, stadiumUuid, stadiumMaterialu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObalMaterialInitDataApi - object-oriented interface
 * @export
 * @class ObalMaterialInitDataApi
 * @extends {BaseAPI}
 */
export class ObalMaterialInitDataApi extends BaseAPI {
    /**
     * Get initial data for obal materialu NR SR.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialInitDataApi
     */
    public getInitialDataForObalMaterialuNrSr(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return ObalMaterialInitDataApiFp(this.configuration).getInitialDataForObalMaterialuNrSr(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get initial data for vseobceny obal materialu.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObalMaterialInitDataApi
     */
    public getInitialDataForObalMaterialuVseobecny(type: string, year: number, index: number, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig) {
        return ObalMaterialInitDataApiFp(this.configuration).getInitialDataForObalMaterialuVseobecny(type, year, index, stadiumUuid, stadiumMaterialu, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OdmietnutieGestoraApi - axios parameter creator
 * @export
 */
export const OdmietnutieGestoraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Reject gestor for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {OdmietnutieGestora} [odmietnutieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectGestor: async (type: string, year: number, index: number, id: string, odmietnutieGestora?: OdmietnutieGestora, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('rejectGestor', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('rejectGestor', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('rejectGestor', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectGestor', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/odmietnutie-gestora/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(odmietnutieGestora, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OdmietnutieGestoraApi - functional programming interface
 * @export
 */
export const OdmietnutieGestoraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OdmietnutieGestoraApiAxiosParamCreator(configuration)
    return {
        /**
         * Reject gestor for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {OdmietnutieGestora} [odmietnutieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectGestor(type: string, year: number, index: number, id: string, odmietnutieGestora?: OdmietnutieGestora, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectGestor(type, year, index, id, odmietnutieGestora, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OdmietnutieGestoraApi.rejectGestor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OdmietnutieGestoraApi - factory interface
 * @export
 */
export const OdmietnutieGestoraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OdmietnutieGestoraApiFp(configuration)
    return {
        /**
         * Reject gestor for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {OdmietnutieGestora} [odmietnutieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectGestor(type: string, year: number, index: number, id: string, odmietnutieGestora?: OdmietnutieGestora, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectGestor(type, year, index, id, odmietnutieGestora, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OdmietnutieGestoraApi - object-oriented interface
 * @export
 * @class OdmietnutieGestoraApi
 * @extends {BaseAPI}
 */
export class OdmietnutieGestoraApi extends BaseAPI {
    /**
     * Reject gestor for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {OdmietnutieGestora} [odmietnutieGestora] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdmietnutieGestoraApi
     */
    public rejectGestor(type: string, year: number, index: number, id: string, odmietnutieGestora?: OdmietnutieGestora, options?: RawAxiosRequestConfig) {
        return OdmietnutieGestoraApiFp(this.configuration).rejectGestor(type, year, index, id, odmietnutieGestora, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PodpisPredseduApi - axios parameter creator
 * @export
 */
export const PodpisPredseduApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Save file with podpis predsedu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [podpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePodpisPredsedu: async (type: string, year: number, index: number, id: string, podpis?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('savePodpisPredsedu', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('savePodpisPredsedu', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('savePodpisPredsedu', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('savePodpisPredsedu', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/podpis-predsedu/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (podpis !== undefined) { 
                localVarFormParams.append('podpis', podpis as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodpisPredseduApi - functional programming interface
 * @export
 */
export const PodpisPredseduApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodpisPredseduApiAxiosParamCreator(configuration)
    return {
        /**
         * Save file with podpis predsedu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [podpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePodpisPredsedu(type: string, year: number, index: number, id: string, podpis?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePodpisPredsedu(type, year, index, id, podpis, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodpisPredseduApi.savePodpisPredsedu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PodpisPredseduApi - factory interface
 * @export
 */
export const PodpisPredseduApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodpisPredseduApiFp(configuration)
    return {
        /**
         * Save file with podpis predsedu for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [podpis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePodpisPredsedu(type: string, year: number, index: number, id: string, podpis?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.savePodpisPredsedu(type, year, index, id, podpis, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodpisPredseduApi - object-oriented interface
 * @export
 * @class PodpisPredseduApi
 * @extends {BaseAPI}
 */
export class PodpisPredseduApi extends BaseAPI {
    /**
     * Save file with podpis predsedu for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {File} [podpis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodpisPredseduApi
     */
    public savePodpisPredsedu(type: string, year: number, index: number, id: string, podpis?: File, options?: RawAxiosRequestConfig) {
        return PodpisPredseduApiFp(this.configuration).savePodpisPredsedu(type, year, index, id, podpis, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PracovnyKrokCompleteApi - axios parameter creator
 * @export
 */
export const PracovnyKrokCompleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete pracovny krok.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePracovnyKrok: async (type: string, year: number, index: number, id: string, pracovnyKrok?: PracovnyKrokEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('completePracovnyKrok', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('completePracovnyKrok', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('completePracovnyKrok', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completePracovnyKrok', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/pracovne-kroky/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pracovnyKrok !== undefined) {
                localVarQueryParameter['pracovnyKrok'] = pracovnyKrok;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracovnyKrokCompleteApi - functional programming interface
 * @export
 */
export const PracovnyKrokCompleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracovnyKrokCompleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Complete pracovny krok.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePracovnyKrok(type: string, year: number, index: number, id: string, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePracovnyKrok(type, year, index, id, pracovnyKrok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracovnyKrokCompleteApi.completePracovnyKrok']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracovnyKrokCompleteApi - factory interface
 * @export
 */
export const PracovnyKrokCompleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracovnyKrokCompleteApiFp(configuration)
    return {
        /**
         * Complete pracovny krok.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePracovnyKrok(type: string, year: number, index: number, id: string, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completePracovnyKrok(type, year, index, id, pracovnyKrok, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracovnyKrokCompleteApi - object-oriented interface
 * @export
 * @class PracovnyKrokCompleteApi
 * @extends {BaseAPI}
 */
export class PracovnyKrokCompleteApi extends BaseAPI {
    /**
     * Complete pracovny krok.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {PracovnyKrokEnum} [pracovnyKrok] Type of pracovny krok.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracovnyKrokCompleteApi
     */
    public completePracovnyKrok(type: string, year: number, index: number, id: string, pracovnyKrok?: PracovnyKrokEnum, options?: RawAxiosRequestConfig) {
        return PracovnyKrokCompleteApiFp(this.configuration).completePracovnyKrok(type, year, index, id, pracovnyKrok, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PracovnyKrokListApi - axios parameter creator
 * @export
 */
export const PracovnyKrokListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get pracovne kroky for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracovnyKrokList: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPracovnyKrokList', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPracovnyKrokList', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPracovnyKrokList', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/pracovne-kroky`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracovnyKrokListApi - functional programming interface
 * @export
 */
export const PracovnyKrokListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracovnyKrokListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get pracovne kroky for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracovnyKrokList(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracovnyKrokList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracovnyKrokList(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracovnyKrokListApi.getPracovnyKrokList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracovnyKrokListApi - factory interface
 * @export
 */
export const PracovnyKrokListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracovnyKrokListApiFp(configuration)
    return {
        /**
         * Get pracovne kroky for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracovnyKrokList(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<PracovnyKrokList> {
            return localVarFp.getPracovnyKrokList(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracovnyKrokListApi - object-oriented interface
 * @export
 * @class PracovnyKrokListApi
 * @extends {BaseAPI}
 */
export class PracovnyKrokListApi extends BaseAPI {
    /**
     * Get pracovne kroky for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracovnyKrokListApi
     */
    public getPracovnyKrokList(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return PracovnyKrokListApiFp(this.configuration).getPracovnyKrokList(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PredkladatelUpdateApi - axios parameter creator
 * @export
 */
export const PredkladatelUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update predkladatel.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PredkladatelUpdate} predkladatelUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePredkladatel: async (type: string, year: number, index: number, predkladatelUpdate: PredkladatelUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updatePredkladatel', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updatePredkladatel', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('updatePredkladatel', 'index', index)
            // verify required parameter 'predkladatelUpdate' is not null or undefined
            assertParamExists('updatePredkladatel', 'predkladatelUpdate', predkladatelUpdate)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/predkladatel`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predkladatelUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredkladatelUpdateApi - functional programming interface
 * @export
 */
export const PredkladatelUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredkladatelUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update predkladatel.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PredkladatelUpdate} predkladatelUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePredkladatel(type: string, year: number, index: number, predkladatelUpdate: PredkladatelUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePredkladatel(type, year, index, predkladatelUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredkladatelUpdateApi.updatePredkladatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredkladatelUpdateApi - factory interface
 * @export
 */
export const PredkladatelUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredkladatelUpdateApiFp(configuration)
    return {
        /**
         * Update predkladatel.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PredkladatelUpdate} predkladatelUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePredkladatel(type: string, year: number, index: number, predkladatelUpdate: PredkladatelUpdate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePredkladatel(type, year, index, predkladatelUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PredkladatelUpdateApi - object-oriented interface
 * @export
 * @class PredkladatelUpdateApi
 * @extends {BaseAPI}
 */
export class PredkladatelUpdateApi extends BaseAPI {
    /**
     * Update predkladatel.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {PredkladatelUpdate} predkladatelUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredkladatelUpdateApi
     */
    public updatePredkladatel(type: string, year: number, index: number, predkladatelUpdate: PredkladatelUpdate, options?: RawAxiosRequestConfig) {
        return PredkladatelUpdateApiFp(this.configuration).updatePredkladatel(type, year, index, predkladatelUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PripomienkovanieApi - axios parameter creator
 * @export
 */
export const PripomienkovanieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Start of stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMpk: async (type: string, year: number, index: number, id: string, mpkRequest?: MpkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('startMpk', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('startMpk', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('startMpk', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startMpk', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/mpk/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mpkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start of stadium vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVyjadrenia: async (type: string, year: number, index: number, id: string, vyjadrenia?: Vyjadrenia, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('startVyjadrenia', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('startVyjadrenia', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('startVyjadrenia', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startVyjadrenia', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/vyjadrenia/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vyjadrenia, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PripomienkovanieApi - functional programming interface
 * @export
 */
export const PripomienkovanieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PripomienkovanieApiAxiosParamCreator(configuration)
    return {
        /**
         * Start of stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startMpk(type: string, year: number, index: number, id: string, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startMpk(type, year, index, id, mpkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkovanieApi.startMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start of stadium vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startVyjadrenia(type: string, year: number, index: number, id: string, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startVyjadrenia(type, year, index, id, vyjadrenia, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkovanieApi.startVyjadrenia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PripomienkovanieApi - factory interface
 * @export
 */
export const PripomienkovanieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PripomienkovanieApiFp(configuration)
    return {
        /**
         * Start of stadium MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMpk(type: string, year: number, index: number, id: string, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startMpk(type, year, index, id, mpkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start of stadium vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVyjadrenia(type: string, year: number, index: number, id: string, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startVyjadrenia(type, year, index, id, vyjadrenia, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PripomienkovanieApi - object-oriented interface
 * @export
 * @class PripomienkovanieApi
 * @extends {BaseAPI}
 */
export class PripomienkovanieApi extends BaseAPI {
    /**
     * Start of stadium MPK for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {MpkRequest} [mpkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkovanieApi
     */
    public startMpk(type: string, year: number, index: number, id: string, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig) {
        return PripomienkovanieApiFp(this.configuration).startMpk(type, year, index, id, mpkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start of stadium vyjadrenia for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {Vyjadrenia} [vyjadrenia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkovanieApi
     */
    public startVyjadrenia(type: string, year: number, index: number, id: string, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig) {
        return PripomienkovanieApiFp(this.configuration).startVyjadrenia(type, year, index, id, vyjadrenia, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PripomienkovanieConfigApi - axios parameter creator
 * @export
 */
export const PripomienkovanieConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Change end date of vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVyjadrenia: async (type: string, year: number, index: number, vyjadrenia?: Vyjadrenia, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('changeVyjadrenia', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('changeVyjadrenia', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('changeVyjadrenia', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/vyjadrenia`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vyjadrenia, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change configuration of mpk for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configMpk: async (type: string, year: number, index: number, mpkRequest?: MpkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('configMpk', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('configMpk', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('configMpk', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/mpk`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mpkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PripomienkovanieConfigApi - functional programming interface
 * @export
 */
export const PripomienkovanieConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PripomienkovanieConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Change end date of vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeVyjadrenia(type: string, year: number, index: number, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeVyjadrenia(type, year, index, vyjadrenia, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkovanieConfigApi.changeVyjadrenia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change configuration of mpk for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configMpk(type: string, year: number, index: number, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configMpk(type, year, index, mpkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkovanieConfigApi.configMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PripomienkovanieConfigApi - factory interface
 * @export
 */
export const PripomienkovanieConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PripomienkovanieConfigApiFp(configuration)
    return {
        /**
         * Change end date of vyjadrenia for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Vyjadrenia} [vyjadrenia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeVyjadrenia(type: string, year: number, index: number, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeVyjadrenia(type, year, index, vyjadrenia, options).then((request) => request(axios, basePath));
        },
        /**
         * Change configuration of mpk for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {MpkRequest} [mpkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configMpk(type: string, year: number, index: number, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.configMpk(type, year, index, mpkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PripomienkovanieConfigApi - object-oriented interface
 * @export
 * @class PripomienkovanieConfigApi
 * @extends {BaseAPI}
 */
export class PripomienkovanieConfigApi extends BaseAPI {
    /**
     * Change end date of vyjadrenia for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {Vyjadrenia} [vyjadrenia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkovanieConfigApi
     */
    public changeVyjadrenia(type: string, year: number, index: number, vyjadrenia?: Vyjadrenia, options?: RawAxiosRequestConfig) {
        return PripomienkovanieConfigApiFp(this.configuration).changeVyjadrenia(type, year, index, vyjadrenia, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change configuration of mpk for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {MpkRequest} [mpkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkovanieConfigApi
     */
    public configMpk(type: string, year: number, index: number, mpkRequest?: MpkRequest, options?: RawAxiosRequestConfig) {
        return PripomienkovanieConfigApiFp(this.configuration).configMpk(type, year, index, mpkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessInstanceRestartApi - axios parameter creator
 * @export
 */
export const ProcessInstanceRestartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Restarts process instance of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartProcessInstance: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('restartProcessInstance', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/restart`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessInstanceRestartApi - functional programming interface
 * @export
 */
export const ProcessInstanceRestartApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessInstanceRestartApiAxiosParamCreator(configuration)
    return {
        /**
         * Restarts process instance of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restartProcessInstance(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restartProcessInstance(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessInstanceRestartApi.restartProcessInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessInstanceRestartApi - factory interface
 * @export
 */
export const ProcessInstanceRestartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessInstanceRestartApiFp(configuration)
    return {
        /**
         * Restarts process instance of legislativny material.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartProcessInstance(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restartProcessInstance(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessInstanceRestartApi - object-oriented interface
 * @export
 * @class ProcessInstanceRestartApi
 * @extends {BaseAPI}
 */
export class ProcessInstanceRestartApi extends BaseAPI {
    /**
     * Restarts process instance of legislativny material.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessInstanceRestartApi
     */
    public restartProcessInstance(uuid: string, options?: RawAxiosRequestConfig) {
        return ProcessInstanceRestartApiFp(this.configuration).restartProcessInstance(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessTerminateApi - axios parameter creator
 * @export
 */
export const ProcessTerminateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Terminate process of specified legislative material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {ProcessTerminate} [processTerminate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateProcess: async (type: string, year: number, index: number, id: string, processTerminate?: ProcessTerminate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('terminateProcess', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('terminateProcess', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('terminateProcess', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('terminateProcess', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/ukoncenie-procesu/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processTerminate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessTerminateApi - functional programming interface
 * @export
 */
export const ProcessTerminateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessTerminateApiAxiosParamCreator(configuration)
    return {
        /**
         * Terminate process of specified legislative material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {ProcessTerminate} [processTerminate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateProcess(type: string, year: number, index: number, id: string, processTerminate?: ProcessTerminate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateProcess(type, year, index, id, processTerminate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessTerminateApi.terminateProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessTerminateApi - factory interface
 * @export
 */
export const ProcessTerminateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessTerminateApiFp(configuration)
    return {
        /**
         * Terminate process of specified legislative material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {ProcessTerminate} [processTerminate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateProcess(type: string, year: number, index: number, id: string, processTerminate?: ProcessTerminate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.terminateProcess(type, year, index, id, processTerminate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessTerminateApi - object-oriented interface
 * @export
 * @class ProcessTerminateApi
 * @extends {BaseAPI}
 */
export class ProcessTerminateApi extends BaseAPI {
    /**
     * Terminate process of specified legislative material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {ProcessTerminate} [processTerminate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessTerminateApi
     */
    public terminateProcess(type: string, year: number, index: number, id: string, processTerminate?: ProcessTerminate, options?: RawAxiosRequestConfig) {
        return ProcessTerminateApiFp(this.configuration).terminateProcess(type, year, index, id, processTerminate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RokovaniePovApi - axios parameter creator
 * @export
 */
export const RokovaniePovApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Start of stadium rokovanie POV for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {RokovaniePov} [rokovaniePov] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRokovaniePov: async (type: string, year: number, index: number, id: string, rokovaniePov?: RokovaniePov, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('startRokovaniePov', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('startRokovaniePov', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('startRokovaniePov', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startRokovaniePov', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/rokovanie-pov/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rokovaniePov, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RokovaniePovApi - functional programming interface
 * @export
 */
export const RokovaniePovApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RokovaniePovApiAxiosParamCreator(configuration)
    return {
        /**
         * Start of stadium rokovanie POV for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {RokovaniePov} [rokovaniePov] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startRokovaniePov(type: string, year: number, index: number, id: string, rokovaniePov?: RokovaniePov, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startRokovaniePov(type, year, index, id, rokovaniePov, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RokovaniePovApi.startRokovaniePov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RokovaniePovApi - factory interface
 * @export
 */
export const RokovaniePovApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RokovaniePovApiFp(configuration)
    return {
        /**
         * Start of stadium rokovanie POV for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {RokovaniePov} [rokovaniePov] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startRokovaniePov(type: string, year: number, index: number, id: string, rokovaniePov?: RokovaniePov, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startRokovaniePov(type, year, index, id, rokovaniePov, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RokovaniePovApi - object-oriented interface
 * @export
 * @class RokovaniePovApi
 * @extends {BaseAPI}
 */
export class RokovaniePovApi extends BaseAPI {
    /**
     * Start of stadium rokovanie POV for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {RokovaniePov} [rokovaniePov] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RokovaniePovApi
     */
    public startRokovaniePov(type: string, year: number, index: number, id: string, rokovaniePov?: RokovaniePov, options?: RawAxiosRequestConfig) {
        return RokovaniePovApiFp(this.configuration).startRokovaniePov(type, year, index, id, rokovaniePov, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchvalenieGestoraApi - axios parameter creator
 * @export
 */
export const SchvalenieGestoraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Odoslat na UV SR na schvalenie gestora.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odoslatNaSchvalenieGestora: async (type: string, year: number, index: number, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('odoslatNaSchvalenieGestora', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('odoslatNaSchvalenieGestora', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('odoslatNaSchvalenieGestora', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('odoslatNaSchvalenieGestora', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/schvalenie-gestora/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchvalenieGestoraApi - functional programming interface
 * @export
 */
export const SchvalenieGestoraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchvalenieGestoraApiAxiosParamCreator(configuration)
    return {
        /**
         * Odoslat na UV SR na schvalenie gestora.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odoslatNaSchvalenieGestora(type: string, year: number, index: number, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odoslatNaSchvalenieGestora(type, year, index, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchvalenieGestoraApi.odoslatNaSchvalenieGestora']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchvalenieGestoraApi - factory interface
 * @export
 */
export const SchvalenieGestoraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchvalenieGestoraApiFp(configuration)
    return {
        /**
         * Odoslat na UV SR na schvalenie gestora.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odoslatNaSchvalenieGestora(type: string, year: number, index: number, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.odoslatNaSchvalenieGestora(type, year, index, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchvalenieGestoraApi - object-oriented interface
 * @export
 * @class SchvalenieGestoraApi
 * @extends {BaseAPI}
 */
export class SchvalenieGestoraApi extends BaseAPI {
    /**
     * Odoslat na UV SR na schvalenie gestora.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchvalenieGestoraApi
     */
    public odoslatNaSchvalenieGestora(type: string, year: number, index: number, id: string, options?: RawAxiosRequestConfig) {
        return SchvalenieGestoraApiFp(this.configuration).odoslatNaSchvalenieGestora(type, year, index, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SprievodnyDokumentMergedListApi - axios parameter creator
 * @export
 */
export const SprievodnyDokumentMergedListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get merged sprievodny dokument list with sprievodny dokument sablona list.
         * @param {string} uuid Primary key of entity
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentListMergedSablonaList: async (uuid: string, typMaterialuUuid?: string, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSprievodnyDokumentListMergedSablonaList', 'uuid', uuid)
            const localVarPath = `/legislativne-materialy/{uuid}/sprievodne-dokumenty`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typMaterialuUuid !== undefined) {
                localVarQueryParameter['typMaterialuUuid'] = typMaterialuUuid;
            }

            if (stadiumUuid !== undefined) {
                localVarQueryParameter['stadiumUuid'] = stadiumUuid;
            }

            if (stadiumMaterialu !== undefined) {
                localVarQueryParameter['stadiumMaterialu'] = stadiumMaterialu;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SprievodnyDokumentMergedListApi - functional programming interface
 * @export
 */
export const SprievodnyDokumentMergedListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SprievodnyDokumentMergedListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get merged sprievodny dokument list with sprievodny dokument sablona list.
         * @param {string} uuid Primary key of entity
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSprievodnyDokumentListMergedSablonaList(uuid: string, typMaterialuUuid?: string, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SprievodnyDokumentMergedItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSprievodnyDokumentListMergedSablonaList(uuid, typMaterialuUuid, stadiumUuid, stadiumMaterialu, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SprievodnyDokumentMergedListApi.getSprievodnyDokumentListMergedSablonaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SprievodnyDokumentMergedListApi - factory interface
 * @export
 */
export const SprievodnyDokumentMergedListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SprievodnyDokumentMergedListApiFp(configuration)
    return {
        /**
         * Get merged sprievodny dokument list with sprievodny dokument sablona list.
         * @param {string} uuid Primary key of entity
         * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
         * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
         * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSprievodnyDokumentListMergedSablonaList(uuid: string, typMaterialuUuid?: string, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<SprievodnyDokumentMergedItem>> {
            return localVarFp.getSprievodnyDokumentListMergedSablonaList(uuid, typMaterialuUuid, stadiumUuid, stadiumMaterialu, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SprievodnyDokumentMergedListApi - object-oriented interface
 * @export
 * @class SprievodnyDokumentMergedListApi
 * @extends {BaseAPI}
 */
export class SprievodnyDokumentMergedListApi extends BaseAPI {
    /**
     * Get merged sprievodny dokument list with sprievodny dokument sablona list.
     * @param {string} uuid Primary key of entity
     * @param {string} [typMaterialuUuid] Uuid of typMaterialu.
     * @param {string} [stadiumUuid] StadiumMaterialuHistoria uuid
     * @param {StadiumMaterialuEnum} [stadiumMaterialu] Stadium of legislativny material.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SprievodnyDokumentMergedListApi
     */
    public getSprievodnyDokumentListMergedSablonaList(uuid: string, typMaterialuUuid?: string, stadiumUuid?: string, stadiumMaterialu?: StadiumMaterialuEnum, options?: RawAxiosRequestConfig) {
        return SprievodnyDokumentMergedListApiFp(this.configuration).getSprievodnyDokumentListMergedSablonaList(uuid, typMaterialuUuid, stadiumUuid, stadiumMaterialu, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UkoncenieVyhodnoteniaMpkApi - axios parameter creator
 * @export
 */
export const UkoncenieVyhodnoteniaMpkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ukoncenie vyhodnotenia MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {UkoncenieVyhodnoteniaMpk} [ukoncenieVyhodnoteniaMpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVyhodnotenieMpk: async (type: string, year: number, index: number, id: string, ukoncenieVyhodnoteniaMpk?: UkoncenieVyhodnoteniaMpk, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('cancelVyhodnotenieMpk', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('cancelVyhodnotenieMpk', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('cancelVyhodnotenieMpk', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelVyhodnotenieMpk', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/ukoncenie-vyhodnotenia-mpk/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ukoncenieVyhodnoteniaMpk, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UkoncenieVyhodnoteniaMpkApi - functional programming interface
 * @export
 */
export const UkoncenieVyhodnoteniaMpkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UkoncenieVyhodnoteniaMpkApiAxiosParamCreator(configuration)
    return {
        /**
         * Ukoncenie vyhodnotenia MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {UkoncenieVyhodnoteniaMpk} [ukoncenieVyhodnoteniaMpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelVyhodnotenieMpk(type: string, year: number, index: number, id: string, ukoncenieVyhodnoteniaMpk?: UkoncenieVyhodnoteniaMpk, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelVyhodnotenieMpk(type, year, index, id, ukoncenieVyhodnoteniaMpk, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UkoncenieVyhodnoteniaMpkApi.cancelVyhodnotenieMpk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UkoncenieVyhodnoteniaMpkApi - factory interface
 * @export
 */
export const UkoncenieVyhodnoteniaMpkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UkoncenieVyhodnoteniaMpkApiFp(configuration)
    return {
        /**
         * Ukoncenie vyhodnotenia MPK for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {UkoncenieVyhodnoteniaMpk} [ukoncenieVyhodnoteniaMpk] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVyhodnotenieMpk(type: string, year: number, index: number, id: string, ukoncenieVyhodnoteniaMpk?: UkoncenieVyhodnoteniaMpk, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelVyhodnotenieMpk(type, year, index, id, ukoncenieVyhodnoteniaMpk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UkoncenieVyhodnoteniaMpkApi - object-oriented interface
 * @export
 * @class UkoncenieVyhodnoteniaMpkApi
 * @extends {BaseAPI}
 */
export class UkoncenieVyhodnoteniaMpkApi extends BaseAPI {
    /**
     * Ukoncenie vyhodnotenia MPK for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {UkoncenieVyhodnoteniaMpk} [ukoncenieVyhodnoteniaMpk] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UkoncenieVyhodnoteniaMpkApi
     */
    public cancelVyhodnotenieMpk(type: string, year: number, index: number, id: string, ukoncenieVyhodnoteniaMpk?: UkoncenieVyhodnoteniaMpk, options?: RawAxiosRequestConfig) {
        return UkoncenieVyhodnoteniaMpkApiFp(this.configuration).cancelVyhodnotenieMpk(type, year, index, id, ukoncenieVyhodnoteniaMpk, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UlohyOrganizacieApi - axios parameter creator
 * @export
 */
export const UlohyOrganizacieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of ulohy organizacie.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [meno] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohyOrganizacie: async (page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, meno?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legislativne-materialy/ulohy/organizacie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (meno !== undefined) {
                localVarQueryParameter['meno'] = meno;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UlohyOrganizacieApi - functional programming interface
 * @export
 */
export const UlohyOrganizacieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UlohyOrganizacieApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of ulohy organizacie.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [meno] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUlohyOrganizacie(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, meno?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UlohyOrganizaciePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUlohyOrganizacie(page, size, sortBy, sortDirection, meno, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UlohyOrganizacieApi.getUlohyOrganizacie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UlohyOrganizacieApi - factory interface
 * @export
 */
export const UlohyOrganizacieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UlohyOrganizacieApiFp(configuration)
    return {
        /**
         * Get list of ulohy organizacie.
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {string} [meno] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohyOrganizacie(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, meno?: string, options?: RawAxiosRequestConfig): AxiosPromise<UlohyOrganizaciePage> {
            return localVarFp.getUlohyOrganizacie(page, size, sortBy, sortDirection, meno, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UlohyOrganizacieApi - object-oriented interface
 * @export
 * @class UlohyOrganizacieApi
 * @extends {BaseAPI}
 */
export class UlohyOrganizacieApi extends BaseAPI {
    /**
     * Get list of ulohy organizacie.
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {string} [meno] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UlohyOrganizacieApi
     */
    public getUlohyOrganizacie(page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, meno?: string, options?: RawAxiosRequestConfig) {
        return UlohyOrganizacieApiFp(this.configuration).getUlohyOrganizacie(page, size, sortBy, sortDirection, meno, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UlohyOrganizacieDetailApi - axios parameter creator
 * @export
 */
export const UlohyOrganizacieDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ulohy for specified user.
         * @param {string} userUuid User id.
         * @param {string} [searchText] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohyOrganizacieDetail: async (userUuid: string, searchText?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('getUlohyOrganizacieDetail', 'userUuid', userUuid)
            const localVarPath = `/legislativne-materialy/ulohy/organizacie/{userUuid}`
                .replace(`{${"userUuid"}}`, encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UlohyOrganizacieDetailApi - functional programming interface
 * @export
 */
export const UlohyOrganizacieDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UlohyOrganizacieDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ulohy for specified user.
         * @param {string} userUuid User id.
         * @param {string} [searchText] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUlohyOrganizacieDetail(userUuid: string, searchText?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UlohaListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUlohyOrganizacieDetail(userUuid, searchText, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UlohyOrganizacieDetailApi.getUlohyOrganizacieDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UlohyOrganizacieDetailApi - factory interface
 * @export
 */
export const UlohyOrganizacieDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UlohyOrganizacieDetailApiFp(configuration)
    return {
        /**
         * Get ulohy for specified user.
         * @param {string} userUuid User id.
         * @param {string} [searchText] 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUlohyOrganizacieDetail(userUuid: string, searchText?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<UlohaListPage> {
            return localVarFp.getUlohyOrganizacieDetail(userUuid, searchText, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UlohyOrganizacieDetailApi - object-oriented interface
 * @export
 * @class UlohyOrganizacieDetailApi
 * @extends {BaseAPI}
 */
export class UlohyOrganizacieDetailApi extends BaseAPI {
    /**
     * Get ulohy for specified user.
     * @param {string} userUuid User id.
     * @param {string} [searchText] 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UlohyOrganizacieDetailApi
     */
    public getUlohyOrganizacieDetail(userUuid: string, searchText?: string, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return UlohyOrganizacieDetailApiFp(this.configuration).getUlohyOrganizacieDetail(userUuid, searchText, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UrcenieGestoraApi - axios parameter creator
 * @export
 */
export const UrcenieGestoraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set gestor and possible spolugestori for specified legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {UrcenieGestora} [urcenieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGestor: async (type: string, year: number, index: number, urcenieGestora?: UrcenieGestora, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('setGestor', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('setGestor', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('setGestor', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/urcenie-gestora`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(urcenieGestora, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UrcenieGestoraApi - functional programming interface
 * @export
 */
export const UrcenieGestoraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UrcenieGestoraApiAxiosParamCreator(configuration)
    return {
        /**
         * Set gestor and possible spolugestori for specified legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {UrcenieGestora} [urcenieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGestor(type: string, year: number, index: number, urcenieGestora?: UrcenieGestora, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGestor(type, year, index, urcenieGestora, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UrcenieGestoraApi.setGestor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UrcenieGestoraApi - factory interface
 * @export
 */
export const UrcenieGestoraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UrcenieGestoraApiFp(configuration)
    return {
        /**
         * Set gestor and possible spolugestori for specified legislativny material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {UrcenieGestora} [urcenieGestora] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGestor(type: string, year: number, index: number, urcenieGestora?: UrcenieGestora, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setGestor(type, year, index, urcenieGestora, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UrcenieGestoraApi - object-oriented interface
 * @export
 * @class UrcenieGestoraApi
 * @extends {BaseAPI}
 */
export class UrcenieGestoraApi extends BaseAPI {
    /**
     * Set gestor and possible spolugestori for specified legislativny material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {UrcenieGestora} [urcenieGestora] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrcenieGestoraApi
     */
    public setGestor(type: string, year: number, index: number, urcenieGestora?: UrcenieGestora, options?: RawAxiosRequestConfig) {
        return UrcenieGestoraApiFp(this.configuration).setGestor(type, year, index, urcenieGestora, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aktualny-pouzivatel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserDetail> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Get current logged user with defined roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VyhlasenievZbierkeApi - axios parameter creator
 * @export
 */
export const VyhlasenievZbierkeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete pracovny krok Pred vyhlasenim v zbierke zakonov SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPredVyhlasenimvZbierkeZakonov: async (type: string, year: number, index: number, id: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('finishPredVyhlasenimvZbierkeZakonov', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('finishPredVyhlasenimvZbierkeZakonov', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('finishPredVyhlasenimvZbierkeZakonov', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('finishPredVyhlasenimvZbierkeZakonov', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/vyhlasene-v-zbierke/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VyhlasenievZbierkeApi - functional programming interface
 * @export
 */
export const VyhlasenievZbierkeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VyhlasenievZbierkeApiAxiosParamCreator(configuration)
    return {
        /**
         * Complete pracovny krok Pred vyhlasenim v zbierke zakonov SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishPredVyhlasenimvZbierkeZakonov(type: string, year: number, index: number, id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishPredVyhlasenimvZbierkeZakonov(type, year, index, id, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VyhlasenievZbierkeApi.finishPredVyhlasenimvZbierkeZakonov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VyhlasenievZbierkeApi - factory interface
 * @export
 */
export const VyhlasenievZbierkeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VyhlasenievZbierkeApiFp(configuration)
    return {
        /**
         * Complete pracovny krok Pred vyhlasenim v zbierke zakonov SR.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishPredVyhlasenimvZbierkeZakonov(type: string, year: number, index: number, id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finishPredVyhlasenimvZbierkeZakonov(type, year, index, id, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VyhlasenievZbierkeApi - object-oriented interface
 * @export
 * @class VyhlasenievZbierkeApi
 * @extends {BaseAPI}
 */
export class VyhlasenievZbierkeApi extends BaseAPI {
    /**
     * Complete pracovny krok Pred vyhlasenim v zbierke zakonov SR.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VyhlasenievZbierkeApi
     */
    public finishPredVyhlasenimvZbierkeZakonov(type: string, year: number, index: number, id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return VyhlasenievZbierkeApiFp(this.configuration).finishPredVyhlasenimvZbierkeZakonov(type, year, index, id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VyjadreniaAdminCancelApi - axios parameter creator
 * @export
 */
export const VyjadreniaAdminCancelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel stadium Vyjadrenia for specified material with admin role.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVyjadrenia: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('cancelVyjadrenia', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('cancelVyjadrenia', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('cancelVyjadrenia', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/zrusenie-vyjadrenia`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VyjadreniaAdminCancelApi - functional programming interface
 * @export
 */
export const VyjadreniaAdminCancelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VyjadreniaAdminCancelApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel stadium Vyjadrenia for specified material with admin role.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelVyjadrenia(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelVyjadrenia(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VyjadreniaAdminCancelApi.cancelVyjadrenia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VyjadreniaAdminCancelApi - factory interface
 * @export
 */
export const VyjadreniaAdminCancelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VyjadreniaAdminCancelApiFp(configuration)
    return {
        /**
         * Cancel stadium Vyjadrenia for specified material with admin role.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelVyjadrenia(type: string, year: number, index: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelVyjadrenia(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VyjadreniaAdminCancelApi - object-oriented interface
 * @export
 * @class VyjadreniaAdminCancelApi
 * @extends {BaseAPI}
 */
export class VyjadreniaAdminCancelApi extends BaseAPI {
    /**
     * Cancel stadium Vyjadrenia for specified material with admin role.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VyjadreniaAdminCancelApi
     */
    public cancelVyjadrenia(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return VyjadreniaAdminCancelApiFp(this.configuration).cancelVyjadrenia(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZapisPredbeznehoStanoviskaApi - axios parameter creator
 * @export
 */
export const ZapisPredbeznehoStanoviskaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Save file with predbezne stanovisko for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePredbezneStanovisko: async (type: string, year: number, index: number, id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('savePredbezneStanovisko', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('savePredbezneStanovisko', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('savePredbezneStanovisko', 'index', index)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('savePredbezneStanovisko', 'id', id)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/zapis-predbezneho-stanoviska/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZapisPredbeznehoStanoviskaApi - functional programming interface
 * @export
 */
export const ZapisPredbeznehoStanoviskaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZapisPredbeznehoStanoviskaApiAxiosParamCreator(configuration)
    return {
        /**
         * Save file with predbezne stanovisko for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePredbezneStanovisko(type: string, year: number, index: number, id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePredbezneStanovisko(type, year, index, id, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZapisPredbeznehoStanoviskaApi.savePredbezneStanovisko']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZapisPredbeznehoStanoviskaApi - factory interface
 * @export
 */
export const ZapisPredbeznehoStanoviskaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZapisPredbeznehoStanoviskaApiFp(configuration)
    return {
        /**
         * Save file with predbezne stanovisko for specified material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} id id of resource
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePredbezneStanovisko(type: string, year: number, index: number, id: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.savePredbezneStanovisko(type, year, index, id, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZapisPredbeznehoStanoviskaApi - object-oriented interface
 * @export
 * @class ZapisPredbeznehoStanoviskaApi
 * @extends {BaseAPI}
 */
export class ZapisPredbeznehoStanoviskaApi extends BaseAPI {
    /**
     * Save file with predbezne stanovisko for specified material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} id id of resource
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZapisPredbeznehoStanoviskaApi
     */
    public savePredbezneStanovisko(type: string, year: number, index: number, id: string, file?: File, options?: RawAxiosRequestConfig) {
        return ZapisPredbeznehoStanoviskaApiFp(this.configuration).savePredbezneStanovisko(type, year, index, id, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZmenaStadiaApi - axios parameter creator
 * @export
 */
export const ZmenaStadiaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Admin function zmena stadia of selected material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ZmenaStadia} [zmenaStadia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMaterialStadium: async (type: string, year: number, index: number, zmenaStadia?: ZmenaStadia, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('changeMaterialStadium', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('changeMaterialStadium', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('changeMaterialStadium', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/zmena-stadia`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zmenaStadia, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZmenaStadiaApi - functional programming interface
 * @export
 */
export const ZmenaStadiaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZmenaStadiaApiAxiosParamCreator(configuration)
    return {
        /**
         * Admin function zmena stadia of selected material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ZmenaStadia} [zmenaStadia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeMaterialStadium(type: string, year: number, index: number, zmenaStadia?: ZmenaStadia, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeMaterialStadium(type, year, index, zmenaStadia, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZmenaStadiaApi.changeMaterialStadium']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZmenaStadiaApi - factory interface
 * @export
 */
export const ZmenaStadiaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZmenaStadiaApiFp(configuration)
    return {
        /**
         * Admin function zmena stadia of selected material.
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ZmenaStadia} [zmenaStadia] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeMaterialStadium(type: string, year: number, index: number, zmenaStadia?: ZmenaStadia, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changeMaterialStadium(type, year, index, zmenaStadia, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZmenaStadiaApi - object-oriented interface
 * @export
 * @class ZmenaStadiaApi
 * @extends {BaseAPI}
 */
export class ZmenaStadiaApi extends BaseAPI {
    /**
     * Admin function zmena stadia of selected material.
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {ZmenaStadia} [zmenaStadia] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZmenaStadiaApi
     */
    public changeMaterialStadium(type: string, year: number, index: number, zmenaStadia?: ZmenaStadia, options?: RawAxiosRequestConfig) {
        return ZmenaStadiaApiFp(this.configuration).changeMaterialStadium(type, year, index, zmenaStadia, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZodpovednyPredkladatelListApi - axios parameter creator
 * @export
 */
export const ZodpovednyPredkladatelListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {number} [size] Size of page to return.
         * @param {string} [userId] User id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZodpovednyPredkladatelList: async (userFullNameContains?: string, size?: number, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/zodpovedni-predkladatelia/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userFullNameContains !== undefined) {
                localVarQueryParameter['userFullNameContains'] = userFullNameContains;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZodpovednyPredkladatelListApi - functional programming interface
 * @export
 */
export const ZodpovednyPredkladatelListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZodpovednyPredkladatelListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {number} [size] Size of page to return.
         * @param {string} [userId] User id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZodpovednyPredkladatelList(userFullNameContains?: string, size?: number, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZodpovednyPredkladatel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZodpovednyPredkladatelList(userFullNameContains, size, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZodpovednyPredkladatelListApi.getZodpovednyPredkladatelList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZodpovednyPredkladatelListApi - factory interface
 * @export
 */
export const ZodpovednyPredkladatelListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZodpovednyPredkladatelListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {number} [size] Size of page to return.
         * @param {string} [userId] User id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZodpovednyPredkladatelList(userFullNameContains?: string, size?: number, userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ZodpovednyPredkladatel>> {
            return localVarFp.getZodpovednyPredkladatelList(userFullNameContains, size, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZodpovednyPredkladatelListApi - object-oriented interface
 * @export
 * @class ZodpovednyPredkladatelListApi
 * @extends {BaseAPI}
 */
export class ZodpovednyPredkladatelListApi extends BaseAPI {
    /**
     * 
     * @param {string} [userFullNameContains] user search name
     * @param {number} [size] Size of page to return.
     * @param {string} [userId] User id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZodpovednyPredkladatelListApi
     */
    public getZodpovednyPredkladatelList(userFullNameContains?: string, size?: number, userId?: string, options?: RawAxiosRequestConfig) {
        return ZodpovednyPredkladatelListApiFp(this.configuration).getZodpovednyPredkladatelList(userFullNameContains, size, userId, options).then((request) => request(this.axios, this.basePath));
    }
}



